import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import Layout from '../../components/Layout';
import { useAuth } from '../../context/AuthContext';
import { filterMenuItems } from '../../utils/menuAccess';
import './CentralPage.css';

const centralItems = [
  { label: 'Sales Monitoring',         icon: '🖥️', path: '/sales-monitoring' },
  { label: 'Express Monitoring',        icon: '🖥️', path: '/express-monitoring' },
  { label: 'Close Sales',              icon: '🔒', path: '/close-sales' },
  { label: 'Schedule Visits',          icon: '👤', path: null },
  { label: 'Winning Numbers',          icon: '🔄', path: '/winning-numbers' },
  { label: 'Connected Bank',           icon: '🏦', path: '/banques-connecte' },
  { label: 'Ticket Query',             icon: '🎫', path: '/verify-ticket' },
  { label: 'See Parameters',           icon: '👤', path: '/see-parameters' },
  { label: 'Send Results',             icon: '🖥️', path: null },
  { label: 'Change Terminal Password', icon: '⚙️', path: '/change-terminal-password' },
  { label: 'Nullify Ticket',           icon: '🚫', path: '/nullify-ticket' },
  { label: 'Revert Nullified Ticket',  icon: '↩️', path: '/revert-nullified-ticket' },
  { label: 'Pay Ticket',               icon: '💵', path: '/pay-ticket' },
];

const CentralPage = () => {
  const { company } = useAuth();
  const visibleItems = useMemo(
    () => filterMenuItems(centralItems, company?.menu_keys),
    [company?.menu_keys],
  );

  return (
    <Layout>
      <p className="central-breadcrumb">
        Ruta: <Link to="/dashboard" className="bc-link">Menu</Link>
        {' >> '}
        <Link to="/central" className="bc-link">Central</Link>
      </p>

      <div className="central-grid">
        {visibleItems.map((item) => (item.path ? (
          <Link key={item.label} to={item.path} className="central-item">
            <div className="central-icon">{item.icon}</div>
            <span className="central-label">{item.label}</span>
          </Link>
        ) : (
          <div key={item.label} className="central-item">
            <div className="central-icon">{item.icon}</div>
            <span className="central-label central-label-disabled">{item.label}</span>
          </div>
        )))}
      </div>
    </Layout>
  );
};

export default CentralPage;
